import React from "react"
import { CreateTaxonomyComponent } from "../../../taxonomy";

export default class CreateCreativeComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    render() {
        return (
            <>
                <CreateTaxonomyComponent
                    {...this.props}
                    isCreative={true}
                />
            </>
        );
    };
};